import axios from "./HttpClient";

import { get, clone } from "lodash";

let localization = {
    welcome: "Welcome",
    completeYourProfile: "Complete your profile",
    registerOrganization: "Register your organization",
    studentRegistration: "Student Registration",
    editProfile: "Update your information",
    update: "Next",
};

let customLocalization = clone(localization);

axios.get(`${IdentityServerUrl}static/branding/content`, { withCredentials: true, params: { locale: navigator.language.substring(0, 2) } }).then((response) => {
    customLocalization = response.data;
});

type localizationType = "welcome" | "completeYourProfile" | "registerOrganization" | "studentRegistration" | "editProfile" | "update";

export default function localize(key: localizationType) {
    return get(customLocalization, key, get(localization, key, ""));
}

const localizationPairs = [
    // ["Send Invites to all Students", "ارسل دعوات لجميع الطلاب"],
    // ["Send Invite", "ارسل دعوة"],
    // ["Send invite to user?", "ارسل دعوة للمستخدم؟"],
    // ["Send invite to all {0} students?", "ارسل دعوة لجميع {0} الطلاب؟"],
    // ["Finished the game? Now take the quiz for your certificate", "انهيت اللعبة؟ الآن قم بإجراء الاختبار للحصول على شهادتك"],
    // ["Email Sent Successfully", "تم ارسال البريد الالكتروني بنجاح"],
    // ["An error occurred while sending the email, please try again later", "حدث خطأ أثناء إرسال البريد الإلكتروني ، يرجى المحاولة مرة أخرى لاحقًا"],
    ["Profile", "اضغط على الملف الشخصي "],
    ["Add Student", "اضغط على اضافة الطالب"],
    ["Continue", "اضغط على استمرار"],
    ["Get Started", "اضغط على ابدأ"],
    ["Help", "للمساعدة اضغط هنا "],
    ["Student Registration", "اضغط على تسجيل الطالب"],
    ["Your School", "اكتب اسم مدرستك"],
    ["Close", "اضغط على اغلاق"],
    ["Download Here", "قم بالتنزيل هنا"],
    ["Add student player", "قم باضافة اللاعب (الطالب) "],
    ["Play the Cyber Defense Day Game", "اضغط على العب( لعبة يوم الدفاع السيبراني)"],
    ["View / Download your certificate", "اضغط على عرض / تحميل شهادتك"],
    ["Edit", "للتعديل اضغط هنا"],
    ["Share", "للمشاركة اضغط هنا"],
    ["Copied to clipboard successfully", "تم النسخ بنجاح"],
    ["Copy the link below to share with your students", "انسخ الرابط أدناه لمشاركته مع طلابك"],
    ["Download All", "اضغط هنا للتحميل "],
    ["Enter your school name as it will appear on the certificates", "أدخل اسم مدرستك كما سيظهر على الشهادة"],
    ["Create", "اضغط على انشاء "],
    ["Come back on 16 November to download the game", "يرجى العودة إلى هذه الصفحة في 16 نوفمبر لتنزيل اللعبة"],
];

export function localizePairs(key: string, ...args: any[]) {
    const pair = localizationPairs.find((pair) => pair[0] === key);
    let result = pair ? pair[1] : key;

    return args.reduce((result, arg, index) => result.replace(`{${index}}`, arg), result);
}

export const HelpText1 = `**GameOn with HP Gaming Garage: Create a Game for Heritage Day with a Touch of South African Flair!**

Dear Gamers and Game Developers,


Are you ready to unleash your creativity and make a positive impact? We're excited to invite you to participate in the GameOn with HP Gaming Garage hackathon, where you'll have the opportunity to create a game that celebrates Heritage Day with South African culture, heritage, and storytelling.


**What's the challenge?**

The theme of this hackathon is Heritage Day, which is celebrated on September 24th every year. We challenge you to incorporate elements of South African culture, heritage, or storytelling into your game to make it more engaging and unique. You can draw inspiration from South Africa's rich history, vibrant culture, and stunning natural beauty to create a game that's both fun and thought-provoking.
`;

export const HelpText2 = `

**How does it work?**

During the hackathon, you'll have access to exclusive resources and guidance from the HP Gaming Garage course, which will equip you with the skills and knowledge you need to bring your game idea to life. You'll have a set amount of time to create your game, and then you'll have the opportunity to showcase your creation to a panel of judges.


**What's at stake?**

The top 10 games will get chance to go to rAge and the best games will win prizes and recognition at the live event. All participants will receive a certificate of participation. But more importantly, you'll have the chance to make a positive impact by creating a game that promotes heritage and unity.


**So, what are you waiting for?** Click on the link below to register for the GameOn HP Gaming Garage Hackathon and get ready to create something amazing!`;
export const HelpText = HelpText1 + HelpText2;

export const RulesText = `
**Participants:** Aged 18+ university undergraduate, game enthusiasts, and tech savvy students in South Africa

**Student Teams:** Teams (with a minimum of 2 and a maximum of 3 members) can participate in the challenge

**Theme:** South African Culture & Heritage

The submissions will go through two levels of judging: In the first round, participants will submit their storyboard, envisioned game artwork and the game relation to the South African heritage and culture. Finalists will be determined and required to create a coded playable PC game. In the finals, three teams will emerge as winners.`;
